import { useState } from 'react'

export const useErrorThrow = () => {
  const [error, setError] = useState<Error | null>(null)
  if (error) {
    console.error('useErrorThrow', error)
    throw error
  }
  return setError
}
